import axios from "axios";

const store = {
    state: {
        service_type: []
    },
    getters: {
        getDeliveryTypes(state) {
            let arr = [];
            for (const [key, value] of Object.entries(state.service_type)) {
                const name = JSON.parse(JSON.stringify(key))
                    .split("_")
                    .join(" ");

                arr.push({
                    value: key,
                    id: value,
                    name
                });
            }

            return arr;
        },
        getServiceTypesByDeliveryType: state => delivery_type => {
            return state.service_type[delivery_type];
        }
    },
    mutations: {
        INITIALIZE_SERVICE_TYPE(state, payload) {
            state.service_type = payload;
        }
    },
    actions: {
        initializeServiceType({ commit, state }) {
            return axios
                .get(this._vm.$endpoints.customer_service_type)
                .then(res => {
                    let response = res.data.data;
                    commit("INITIALIZE_SERVICE_TYPE", response);
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
};

export default store;
